/**
 * Eye animation Functions
 */

// Generate random number in specified range
const randRange = (min, max) => {
    return Math.random() * (max - min) + min;
}

// Smoothly move the eye from center to specified x,y rotation, wait t, then return to center
const eyeTo = (mesh, x, y, t = 1) => {
    if (mesh.userData.eyeMoveAction) {
        mesh.userData.eyeMoveAction.stop()
    }
    const mixer = mesh.userData.mixer
    mixer.uncacheAction(mesh.userData.eyeMoveAction)

    const moveTime = randRange(0.1, 0.2)
    const times = [0, 0.5 * moveTime, moveTime]
    const xValues = [0, 0.5 * x, x]
    const yValues = [0, 0.5 * y, y]
    const xTrack = new THREE.NumberKeyframeTrack('.rotation[y]', times, xValues, THREE.InterpolateSmooth)
    const yTrack = new THREE.NumberKeyframeTrack('.rotation[x]', times, yValues, THREE.InterpolateSmooth)
    const clip = new THREE.AnimationClip(null, moveTime + t, [xTrack, yTrack])
    mesh.userData.eyeMoveAction = mixer.clipAction(clip)
    mesh.userData.eyeMoveAction.setLoop(THREE.LoopPingPong, 2)

    mesh.userData.eyeMoveAction.play()
    mesh.userData.nextEyeMovement += 2 * (moveTime + t)
}

// Generate blink animation (hack using material opacity)
const blink = (mesh) => {
    if (mesh.userData.blinkAction) {
        mesh.userData.blinkAction.reset()
    } else {
        const blinkTime = 0.15
        const blinkHoldTime = 0.03
        const blinkTrack = new THREE.NumberKeyframeTrack('.material[opacity]', [0, 0.5 * blinkTime, blinkTime], [1, 0.5, 0], THREE.InterpolateSmooth)
        const mixer = mesh.userData.mixer
        mesh.userData.blinkAction = mixer.clipAction(new THREE.AnimationClip('blink', blinkTime + blinkHoldTime, [blinkTrack]))
        mesh.userData.blinkAction.setLoop(THREE.LoopPingPong, 2)
    }
    mesh.userData.blinkAction.play()
}

// Pupil dilation animation (hack using aoMapIntensity)
// amt is amount to dilate (-1 to +1), t is hold time before returning to normal
const dilateTo = (mesh, amt, t = 1) => {
    if (mesh.userData.eyeDilateAction) {
        mesh.userData.eyeDilateAction.stop()
    }
    const mixer = mesh.userData.mixer
    mixer.uncacheAction(mesh.userData.eyeDilateAction)

    const dilateTime = randRange(3, 5)
    const times = [0, 0.5 * dilateTime, dilateTime]
    const values = [0, 0.5 * amt, amt]
    const track = new THREE.NumberKeyframeTrack('.material[aoMapIntensity]', times, values, THREE.InterpolateSmooth)
    const clip = new THREE.AnimationClip(null, dilateTime + t, [track])
    mesh.userData.eyeDilateAction = mixer.clipAction(clip)
    mesh.userData.eyeDilateAction.setLoop(THREE.LoopPingPong, 2)

    mesh.userData.eyeDilateAction.play()
    mesh.userData.nextDilation += 2 * (dilateTime + t)
}


/**
 * Probabilistically run eye animations (call each tick)
 */
const eyeAnimation = (mesh, clock) => {
    const properties = mesh.userData.properties
    if (clock.elapsedTime > mesh.userData.nextEyeMovement) {
        mesh.userData.nextEyeMovement = clock.elapsedTime + randRange(properties.eyeMovementMinPeriod, properties.eyeMovementMaxPeriod)

        if (Math.random() < properties.eyeMovementProbability) {
            eyeTo(mesh, randRange(-properties.eyeMovementRange, properties.eyeMovementRange), randRange(-properties.eyeMovementRange, properties.eyeMovementRange), randRange(properties.eyeHoldTimeMin, properties.eyeHoldTimeMax))
        }
    }

    if (clock.elapsedTime > mesh.userData.nextBlink) {
        mesh.userData.nextBlink = clock.elapsedTime + randRange(properties.blinkMinPeriod, properties.blinkMaxPeriod)

        if (Math.random() < properties.blinkProbability) {
            blink(mesh)
        }
    }

    if (clock.elapsedTime > mesh.userData.nextDilation) {
        mesh.userData.nextDilation = clock.elapsedTime + randRange(properties.dilationMinPeriod, properties.dilationMaxPeriod)

        if (Math.random() < properties.dilationProbability) {
            dilateTo(mesh, randRange(-1, 1), randRange(properties.dilationHoldTimeMin, properties.dilationHoldTimeMax))
        }
    }
}

export { eyeAnimation }